import React from 'react';
import SectionPage from '../../Components/Paper/SectionPage';
import ActivityEntryItem from './Components/ActivityEntryItem';

const renderEntryComponent = (data) => (
  <ActivityEntryItem key={`${data?.id}`} data={data} />
);

const PrioritiesPage = function PrioritiesPage({ priorities = [] }) {
  return (
    <>
      <SectionPage
        sectionName="PRIORITIES"
        customEntryFunction={(item) => renderEntryComponent(item)}
        singlePageList={priorities}
        hideFilters
        hideSorting
        hideSearchBar
        hideExportExcel
      />
    </>
  );
};

export default PrioritiesPage;
